import { mapRecordFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetOneResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import {
  ISubmitOrderLogEntryDetail,
  ISubmitOrderLogReport,
  ISubmitOrderLogReportRequestPayload,
} from 'dashboard/types';

export const getSubmitOrderLogReport = async (
  requestPayload: ISubmitOrderLogReportRequestPayload,
  signal?: AbortSignal
): Promise<GetOneResponse<ISubmitOrderLogReport>> => {
  const { data } = await partfinitiClient.get(
    `/quote/submit-order-log/report?${getQueryStringToSnakeCase(requestPayload, {
      removeNullValues: true,
    })}`,
    signal
  );

  return mapRecordFromServer<ISubmitOrderLogReport>(data.data);
};

export const getSubmitOrderLogEntry = async (
  id: number,
  signal?: AbortSignal
): Promise<ISubmitOrderLogEntryDetail> => {
  const { data } = await partfinitiClient.get(
    `/quote/submit-order-log/entry?${getQueryStringToSnakeCase({ id })}`,
    signal
  );

  const entry = data.data ?? {};

  // Deliberately NOT run through the snake->camel mapper: the request/response
  // bodies must reach the clipboard key-for-key identical, never re-cased. The
  // hazard is not snake_case — the DDP payload is camelCase — but its mixed-case
  // acronyms and PascalCase keys, which the mapper recurses into and rewrites:
  // addCPN -> addCpn, enteredCostUOM -> enteredCostUom, and ErrorMessage.Error ->
  // errorMessage.error in failure responses.
  return {
    id: entry.id,
    createdAt: entry.created_at,
    orderId: entry.order_id,
    requestUrl: entry.request_url,
    requestBody: entry.request_body,
    responseStatus: entry.response_status,
    responseBody: entry.response_body,
  };
};
